import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector, useDispatch, Provider } from 'react-redux';
import { Toaster } from "react-hot-toast";
import { store } from './app/store';

// Layouts
import Layout from './components/Layout';
import OutletLayout from './pages/DeliveryBoy/Outlet';

// User Pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import OurStore from './pages/OurStroe';
import Wishlist from './pages/Wishlist';
import Login from './pages/LoginPage';
import Forgetpassword from './pages/Forgetpassword';
import Signup from './pages/Signup';
import Resetpassword from './pages/Resetpassword';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import TermAndConditions from './pages/TermAndConditions';
import ShippingPolicy from './pages/ShippingPolicy';
import SingleProduct from './pages/SingleProduct';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import UserProfile from './pages/userprofile';
import OrderDetails from './pages/OrderDetails';
import TrackOrder from './pages/Trackorder';
import RudrakshaCalculator from './pages/RudrakshaCalculator';
import ConsultationPage from './pages/ConsultationPage';
import HeroSection from './pages/HeroSection';

// Delivery Boy Pages
import Dashboard from './pages/DeliveryBoy/Dashboard';
import AssignOrders from './pages/DeliveryBoy/AssignOrders';
// import ProfileSetUp from './pages/DeliveryBoy/ProfileSetUp';
import Reports from './pages/DeliveryBoy/Reports';

// Thunks
import { getUserCart, getUserProductWishlist } from './features/user/userSlice';

// Private Route Wrapper
const PrivateRoute = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

// Delivery Boy Route Wrapper
const DeliveryBoyRoute = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  return isAuthenticated && user?.role === 'deliveryboy' ? (
    <OutletLayout />
  ) : (
    <Navigate to="/login" replace />
  );
};

function AppContent() {
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.auth); // Added 'user' here

  // Trigger cart & wishlist fetch on refresh for non-delivery boys
  useEffect(() => {
    if (isAuthenticated && user?.role !== 'deliveryboy') {
      dispatch(getUserCart());
      dispatch(getUserProductWishlist());
    }
  }, [dispatch, isAuthenticated, user]);


  const ScrollToTop = () => {
    const { pathname } = useLocation();
    const lastPathname = React.useRef(pathname);

    useEffect(() => {
      if (pathname !== lastPathname.current) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
        lastPathname.current = pathname;
      }
    }, [pathname]);

    return null;
  };

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Customer Frontend */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="product" element={<OurStore />} />
            <Route path="product/:id" element={<SingleProduct />} />
            <Route path="cart" element={<Cart />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="wishlist" element={<Wishlist />} />
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<Signup />} />
            <Route path="forget-password" element={<Forgetpassword />} />
            <Route path="/reset-password/:token" element={<Resetpassword />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="Cancellation-Refunds" element={<RefundPolicy />} />
            <Route path="shipping-policy" element={<ShippingPolicy />} />
            <Route path="terms-conditions" element={<TermAndConditions />} />

            {/* Protected User Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/profile" element={<UserProfile />} />
              <Route path="/profile/:id" element={<UserProfile />} />
              <Route path="/profile/:id/:section" element={<UserProfile />} />
              <Route path="/account" element={<UserProfile />} />
              <Route path="/password" element={<UserProfile />} />
              <Route path="/address" element={<UserProfile />} />
              <Route path="/orders" element={<UserProfile />} />
              <Route path="/order/:id" element={<OrderDetails />} />
              <Route path="/track" element={<UserProfile />} />
              <Route path="rudrakshaCalculator" element={<RudrakshaCalculator />} />
              <Route path="consultationPage" element={<ConsultationPage />} />
              <Route path="heroSection" element={<HeroSection />} />
            </Route>
          </Route>

          {/* Delivery Boy Routes */}
          <Route path="/deliveryboy" element={<DeliveryBoyRoute />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="assigned-orders" element={<AssignOrders />} />
            <Route path="reports" element={<Reports />} />
            {/* <Route path="profileSetUp" element={<ProfileSetUp />} /> */}
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;